import { ActionBarButton, ActionBarItemGroup } from "../item";
import SyncModal from "../../modals/sync/index";
import ConfirmModal from "../../modals/confirm/index";
import MessageModal from "../../modals/message/index";


/** Button for navigating back to home screen. */
export class HomeButton extends ActionBarButton
{
    public title = 'Home';
    public iconClassList = 'im im-home';
    public group = ActionBarItemGroup.RIGHT;
    public hash = '#/';

    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Home');
        return super.beforeRender();
    }
}

/** Button for logging out the currently authenticated user. */
export class LogoutButton extends ActionBarButton
{
    public title = 'Log out';
    public iconClassList = 'im im-exit';
    public group = ActionBarItemGroup.RIGHT;

    public onClick(e: MouseEvent)
    {
        this.app.logout();
    }

    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Log out');
        return super.beforeRender();
    }
}

export class SyncButton extends ActionBarButton
{
    public title = 'Synchronization';
    public iconClassList = 'im im-cloud-check';
    public group = ActionBarItemGroup.RIGHT;

    public onClick(e: MouseEvent): void
    {
        this.app.modals.show(new SyncModal());
    }


    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Synchronization');
        return super.beforeRender();
    }
}

export class InfoButton extends ActionBarButton
{
    public iconClassList = 'im im-info';
    public group = ActionBarItemGroup.RIGHT;
    
    public onClick(e: MouseEvent): void
    {
        let modal = new MessageModal(this.pgettext('Message', 
            `
            Application version: {version}<br />
            Most recent sync: {last_sync}
            `, {
                version: this.app.settings.version.verbose,
                last_sync: this.app.synchronizer.lastSyncTimestamp.value
            }),
            this.pgettext('Title', 'Information')
        );

        this.app.modals.show(modal);
    }


    public beforeRender(): PromiseLike<void>
    {
        this.title = this.app.pgettext('Action bar', 'Info');
        return super.beforeRender();
    }
}